import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../styles/AdminSliders.css";

const AdminSliders = () => {

  const [sliders,setSliders] = useState([]);

  const [form,setForm] = useState({
    type:"image",
    title:"",
    description:"",
    button_text:"",
    button_link:""
  });

  const [media,setMedia] = useState(null);
  const [editId,setEditId] = useState(null);

  /* ================= LOAD SLIDERS ================= */

  const loadSliders = async () => {

    try{

      const res = await axios.get("/api/sliders");

      setSliders(res.data);

    }catch(err){
      console.log(err);
    }

  }

  useEffect(()=>{

    loadSliders();

  },[]);

  /* ================= INPUT CHANGE ================= */

  const handleChange = (e) => {

    setForm({
      ...form,
      [e.target.name]:e.target.value
    });

  }

  /* ================= FILE CHANGE ================= */

  const handleFile = (e) => {

    setMedia(e.target.files[0]);

  }

  /* ================= ADD / UPDATE ================= */

const handleSubmit = async (e) => {
  e.preventDefault();

  const data = new FormData();
  data.append("type", form.type);
  data.append("title", form.title);
  data.append("description", form.description);
  data.append("button_text", form.button_text);
  data.append("button_link", form.button_link);

  if (media) data.append("media", media);

  try {
    if (editId) {
      await axios.put(`/api/sliders/${editId}`, data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert("Slider Updated");
    } else {
      await axios.post("/api/sliders", data, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      alert("Slider Added");
    }

    setForm({
      type: "image",
      title: "",
      description: "",
      button_text: "",
      button_link: ""
    });
    setMedia(null);
    setEditId(null);

    loadSliders();
  } catch (err) {
    console.log(err);
    alert("Error saving slider");
  }
};
  /* ================= EDIT ================= */

  const editSlider=(item)=>{

    setEditId(item.id);

    setForm({
      type:item.type,
      title:item.title,
      description:item.description,
      button_text:item.button_text || "",
      button_link:item.button_link || ""
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  /* ================= DELETE ================= */

  const deleteSlider = async(id)=>{

    if(!window.confirm("Delete slider?")) return;

    await axios.delete(
      `/api/sliders/${id}`);

    loadSliders();

  }

  /* ================= STATUS ================= */

  const toggleStatus = async(id)=>{

    await axios.put(
      `/api/sliders/status/${id}`);

    loadSliders();

  }

  return(

  <div className="slider-admin">

  <h2 className="admin-title">Slider Manager</h2>

  {/* ================= FORM ================= */}

  <form className="slider-form" onSubmit={handleSubmit}>

    <select
      name="type"
      value={form.type}
      onChange={handleChange}
    >
      <option value="image">Image</option>
      <option value="video">Video</option>
    </select>

    <input
      type="text"
      name="title"
      placeholder="Title"
      value={form.title}
      onChange={handleChange}
      required
    />

    <input
      type="text"
      name="description"
      placeholder="Description"
      value={form.description}
      onChange={handleChange}
    />

    <input
      type="text"
      name="button_text"
      placeholder="Button Text"
      value={form.button_text}
      onChange={handleChange}
    />

    <input
      type="text"
      name="button_link"
      placeholder="Button Link"
      value={form.button_link}
      onChange={handleChange}
    />

    <input
      type="file"
      onChange={handleFile}
    />

    <button type="submit">
      {editId ? "Update Slider" : "Add Slider"}
    </button>

  </form>

  {/* ================= TABLE ================= */}

  <table className="slider-table">

  <thead>

  <tr>

  <th>Media</th>
  <th>Title</th>
  <th>Description</th>
  <th>Button</th>
  <th>Status</th>
  <th>Action</th>

  </tr>

  </thead>

  <tbody>

  {sliders.map((item)=>{

  const mediaUrl=`${BASE_URL}/uploads/${
  item.type==="image"?"images":"videos"
  }/${item.media}`;

  return(

  <tr key={item.id}>

  <td>

  {item.type==="image" ? (

  <img
  src={mediaUrl}
  alt=""
  className="media-preview"
  />

  ):(

  <video
  src={mediaUrl}
  className="media-preview"
  controls
  />

  )}

  </td>

  <td>{item.title}</td>

  <td className="desc">{item.description}</td>

  <td>
  {item.button_text && item.button_link && (
  <a
    href={item.button_link}
    target="_blank"
    rel="noreferrer"
    className="btn-link"
  >
    {item.button_text}
  </a>
)}
  </td>

  <td>

  <button
  className={item.status ? "status-active":"status-off"}
  onClick={()=>toggleStatus(item.id)}
  >

  {item.status ? "Active":"Inactive"}

  </button>

  </td>

  <td>

  <button
  className="edit-btn"
  onClick={()=>editSlider(item)}
  >
  Edit
  </button>

  <button
  className="delete-btn"
  onClick={()=>deleteSlider(item.id)}
  >
  Delete
  </button>

  </td>

  </tr>

  )

  })}

  </tbody>

  </table>

  </div>

  )

}

export default AdminSliders;